export default "__VITE_ASSET__0eFx7Iut__"